export const SHOPIFY_DOMAIN = '.myshopify.com'
export const BIGCOMMERCE_DOMAIN = '.mybigcommerce.com'
